import React, { useCallback } from 'react';
import Modal from '../helpers/Modal';
import { KnightKey } from '../../types';
import { capitalize } from '../../utils/capitalize';
import { SWORN_DATA } from '../../gameData';
import { GameEntityCard } from '../ui/GameEntityCard';
import { getIconPath } from '../../utils/iconPath';

interface KnightSelectorModalProps {
    isOpen: boolean;
    onClose: () => void;
    selectedKnight: KnightKey | null;
    setSelectedKnight: (k: KnightKey) => void;
}

const KnightSelectorModal: React.FC<KnightSelectorModalProps> = ({ isOpen, onClose, selectedKnight, setSelectedKnight }) => {
    const knightKeys = (SWORN_DATA.ui_config?.knight_sort_order || Object.keys(SWORN_DATA.classes)) as KnightKey[];

    const handleSelect = useCallback((key: string) => {
        setSelectedKnight(key as KnightKey);
        onClose();
    }, [setSelectedKnight, onClose]);

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Select Your Knight" size="2xl">
            <div className="flex flex-wrap gap-4 justify-center">
                {knightKeys.map((knightKey) => (
                    <GameEntityCard
                        key={knightKey}
                        id={knightKey}
                        title={capitalize(knightKey)}
                        iconPath={getIconPath('knight', knightKey)}
                        isSelected={selectedKnight === knightKey}
                        onClick={handleSelect}
                        description={`${SWORN_DATA.classes[knightKey].base_description.split('.')[0]}...`}
                        className="w-32"
                    />
                ))}
            </div>
        </Modal>
    );
};

export default KnightSelectorModal;